import React, { useState, Fragment, useEffect } from 'react';
import Layout from '../../Layout/Layout';
import DataTable from "react-data-table-component";
import { Form } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { CollectionPromotionAction } from '../../actions/users';
import moment from 'moment';
import { toast } from 'react-toastify';
import { isEmpty } from '../../actions/commonFunction';

const CollectionPromotion = () => {


    const navigate = useNavigate()
    const { Id } = useParams();


    const [Collection, SetCollection] = useState([
            {
                "EmailAddress": "dummy@gmial.com",
                "Name": "maticz",
                "Subject": "summy subject",
                "Detail": "dummy detailssss",
                "NFTCategory": "dummy detailssss",
                "NFTRoyality": "dummy detailssss",
                "ListStatus": "dummy detailssss",
                "ListedQuantity": "dummy detailssss",
                "NFTQuantity": "dummy detailssss",
            },
        ]);
    
        useEffect(() => {
            if(Id){
                getCollectionlist();
            }
            }, [Id])
        
            const getCollectionlist = async () => {
                let senddata = {
                    type : 'get',
                    Category: Id,
                }
                var test = await CollectionPromotionAction(senddata);
                
                SetCollection(test.data);
            }

        const columns = [
           
            {
    
                key: "Collection Name",
                name: "Collection Name",
                // // className: "tokenId",
                align: "left",
                sortable: false,
                cell: (row, index, column, id) => (
                    <p>{row?.collectionName}</p>
                ),
    
            },
            {
    
                key: "Creator",
                name: "Creator",
                // // className: "tokenId",
                align: "left",
                sortable: false,
                cell: (row, index, column, id) => (
                    <p>{isEmpty(row?.CreatorName)? row?.userAddress :  row.CreatorName }</p>
                ),
    
            },
            {
    
                key: "Date",
                name: "Date",
                // // className: "tokenId",
                align: "left",
                sortable: false,
                cell: (row, index, column, id) => (
                    <p>{moment(row.createdAt).format('MMMM,Do YYYY, hh:mm A')}</p>
                ),
    
            },
            {
    
                key: "Collection Promotion",
                name: "Collection Promotion",
                // className: "tokenBid",
                align: "left",
                sortable: false,
                cell: (row, index, column, id) => {
                    return (
                        <Fragment>
                            <Form.Check type="checkbox" checked={row?.Promotion} onClick={() => CollectionPromotionEdit(row)} />
                        </Fragment>
                    );
                }
    
            },
        ];

        const CollectionPromotionEdit = async(data) => {
      
            if(data?._id!='') {
                let Senddata = {
                    type : 'edit',
                    id: data._id,
                    promotion: data.Promotion,
                }
              let Resp = await CollectionPromotionAction(Senddata);
              
              if(Resp?.success){
                toast.success(Resp.message,1000);
                getCollectionlist();
              }
              else{
                toast.error('Error Occured')
              }
            }
            
        }

    return (
        <Layout>
            <div className="collectionlist">
                <h1 className="pagehead">Collection List</h1>
                <div className="cardbox">
                    <div className="tablebox">
                        <Form.Control type="text" placeholder="Filter in records" />
                        <DataTable
                            className='react-datatables'
                            columns={columns}
                            data={Collection}
                            pagination // Enable pagination
                            // paginationPerPage={2} // Rows per page
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default CollectionPromotion;